import { Typography } from '@mui/material';
import { InteractiveModal } from 'components/Modals/InteractiveModal/BaseModal';
import AssetHandler from 'handlers/asset.handler';
import DeviceHandler from 'handlers/device.handler';
import { useTranslation } from 'react-i18next';

export {};

/**
 *
 * The delete modal is a modal that is used to delete an Asset.
 */

interface Props {
  open: boolean;
  assetId: string;
  assetVin: string;
  deviceId?: string;
  handleAbort: () => void;
}

export const AssetDeactivationModal = ({
  open,
  assetId,
  assetVin,
  deviceId,
  handleAbort,
}: Props) => {
  const { t } = useTranslation();
  const assetHandler = new AssetHandler();
  const deviceHandler = new DeviceHandler();
  const title = `Confirm Asset Deletion`;
  return (
    <InteractiveModal
      initialState={open}
      title={title}
      handleAbort={handleAbort}
      SuccessButtonProps={{
        onClick: async () => {
          if (deviceId) {
            await deviceHandler.updateDevice(deviceId, {
              assetId: null,
            });
          }
          await assetHandler.deleteAsset(assetId, assetVin);
          handleAbort();
        },
        disabled: false,
        label: t('delete_asset'),
      }}
      ModalContentProps={{
        gridItemProps: {
          lg: 12,
        },
      }}
    >
      <Typography key="blurb-1" variant="medium">
        {t('are_you_sure_you_want_to_delete_asset')} {assetVin}
      </Typography>
      <Typography key="blurb-2" variant="medium"></Typography>
    </InteractiveModal>
  );
};
